import * as customPages from "../schemas/custom-pages";

export default () => {
  return ["page", "destination", ...Object.keys(customPages)].map((type) => {
    return {
      type: type
    };
  });
};
